import React from 'react'
import styled from 'styled-components'

import { FONTS } from '../../../../constants'
import { SearchSelect } from '../../../input'

export const CompanyInfoFirstCol = props => {
  const {
    _companys,
    _lobs,
    _positions,
    _departments,
    movementData,
    handleInput,
  } = props

  const position = _positions.find(e => e._id === movementData.position_id) || null
  const company = _companys.find(e => e._id === movementData.company_id) || null
  const lob = _lobs.find(e => e._id === movementData.lob_id) || null
  const department = _departments.find(e => e._id === movementData.department_id) || null

  return (
    <FormWrapper>
      <FormGroup>
        <LabelCol>
          <Label>Position</Label>
        </LabelCol>
        <InputCol>
          <SearchSelect
            name='position_id'
            placeholder='Select Position'
            value={ position }
            options={ _positions }
            onChange={ e => handleInput(e, 'position_id') }
          />
        </InputCol>
      </FormGroup>
      <FormGroup>
        <LabelCol>
          <Label>Company</Label>
        </LabelCol>
        <InputCol>
          <SearchSelect
            name='company_id'
            placeholder='Select Company'
            value={ company }
            options={ _companys }
            onChange={ e => handleInput(e, 'company_id') }
          />
        </InputCol>
      </FormGroup>
      <FormGroup>
        <LabelCol>
          <Label>LOB</Label>
        </LabelCol>
        <InputCol>
          <SearchSelect
            name='lob_id'
            placeholder='Select LOB'
            value={ lob }
            options={ company ? _lobs.filter(l => l.company_id === company._id) : [] }
            onChange={ e => handleInput(e, 'lob_id') }
          />
        </InputCol>
      </FormGroup>
      <FormGroup>
        <LabelCol>
          <Label>Department</Label>
        </LabelCol>
        <InputCol>
          <SearchSelect
            name='department_id'
            placeholder='Select Department'
            value={ department }
            options={ lob ? _departments.filter(d => d.lob_id === lob._id) : [] }
            onChange={ e => handleInput(e, 'department_id') }
          />
        </InputCol>
      </FormGroup>
    </FormWrapper>
  )
}

const Label = styled.span`
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;

    ${p => p.required && `
      ::after {
        content: '*';
        color: red;
      }
    `}
`

const FormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;

    :nth-child(1) {
        padding-right: 6px;
    }

    :nth-last-child(1) {
        padding-left: 6px;
    }
`

const FormGroup = styled.div`
    display: flex;
    margin-bottom: 16px;
`

const LabelCol = styled.div`
    display: flex;
    flex: 1;
`

const InputCol = styled.div`
    display: flex;
    flex: 2;

    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;
`



// WEBPACK FOOTER //
// ./src/components/new-employee/movement/create-movement/first-column.js